import { CSSObject } from '@chakra-ui/react';
import { BannerSchema } from '@/views/account/Overview/components/Banner/styles/Banner.styles';
import bg from '@/assets/chromabet/images/account/bannerBg.png';
import bgMb from '@/assets/chromabet/images/account/bannerBgMb.png';

export const bannerStyles: BannerSchema = {
  buttonDeposit: {
    variant: 'odds',
  },
};
export const FlexBannerContainer: CSSObject = {
  borderRadius: 'md',
  bgImage: [`url(${bgMb})`, null, `url(${bg})`],
  bgSize: 'cover',
  color: 'white',
  gap: '0',
  p: ['2', null, '3'],
  minH: '107px',
};
export const FlexAccountDetails: CSSObject = {
  alignItems: [null, null, 'center'],
  flexDir: ['column', null, 'row'],
  gap: '1.5',
  borderBottom: '1px dashed',
  borderBottomColor: '#1C233F',
};
export const FlexAccountName: CSSObject = {
  fontSize: 'md',
  fontFamily: 'accent',
  fontWeight: 'bold',
  color: 'beta.400',
  textTransform: 'capitalize',
  textShadow: '0px 0px 8px rgba(37, 254, 214, 0.7)',
};
export const FlexAccountBalances: CSSObject = {
  gap: '8',
  mt: [null, null, '0'],
  mr: [null, null, '-2'],
  px: [null, null, '4'],
  py: ['3', null, '2'],
};
export const FlexBannerBalanceInner: CSSObject = {
  flex: ['1', null, '0 1 auto'],
  alignItems: ['start', null, 'end'],
};
export const TextAccountBalanceLabel: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  fontFamily: 'accent',
  textAlign: ['start', null, 'end'],
};
export const FlexAccountBalanceWrapper: CSSObject = {
  fontSize: 'md',
  fontFamily: 'accent',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  textShadow: '0px 0px 8px rgba(37, 254, 214, 0.7)',
};
export const TextAccountBalanceCurrencySymbol = (): CSSObject => ({
  display: 'inline',
  verticalAlign: 'super',
  color: 'beta.400',
});
export const TextAccountBalanceBaseUnit = (): CSSObject => ({
  color: 'beta.400',
});
export const TextAccountBalanceSubUnit = (): CSSObject => ({
  color: 'beta.400',
});
export const FlexButtonContainer: CSSObject = {
  flexDir: ['column', null, 'row'],
  gap: '2',
  borderTop: '1px dashed',
  borderTopColor: '#dddddd20',
  pt: '2',
};
export const TextButton: CSSObject = {
  h: '4',
  fontSize: 'xs',
  fontFamily: 'accent',
  textTransform: 'uppercase',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
};
export const FlexBalanceBetInfo: CSSObject = {
  bg: 'transparent',
  borderRadius: 'md',
  border: '1px',
  borderColor: 'beta.400',
  color: 'white',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  fontFamily: 'accent',
  fontSize: 'xs',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  alignItems: 'center',
  h: '10',
  justifyContent: 'center',
  flex: ['1', null, '0'],
  px: '4',
  py: '3',
  whiteSpace: [null, null, 'nowrap'],
};
export const FlexLabel: CSSObject = {
  flexDirection: ['column', null, 'row'],
};
